import React from 'react';

export const BrowseTags: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg viewBox="0 0 20 21" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#697180">
      <path strokeLinecap="round" d="M14.396 14.397l3.54 3.54" />
      <path d="M14.336 4.17A7.19 7.19 0 0 1 4.17 14.337 7.19 7.19 0 0 1 14.336 4.17z" />
      <path
        strokeLinecap="round"
        d="M7.736 10.418l-.338 2.1M8.492 5.987l-.7 4.178M10.883 7.866l-.775 4.653M11.182 5.987l-.297 1.879M8.527 7.823h3.9M6.434 7.823h1.74M10.367 10.486h1.95M6.079 10.486h3.999"
      />
    </g>
  </svg>
);
